import { useQuery } from '@tanstack/react-query';
import requests from 'service/api';
import SearchSelect from '../search-select';
import { useEffect, useState, useMemo } from 'react';
import { useFormikContext } from 'formik';

export function SelectReferanceCode4HomeInner({ name,other }) {
  const { values, setFieldValue } = useFormikContext();
  const [selected, setSelected] = useState(null);
  
  // name prop'undan path'i çıkar (örn: "beltLabel[0].sizes[1].referanceCode")
  const getValueFromPath = (path, obj) => {
    return path.split('.').reduce((current, key) => {
      // Array index'leri için [0] formatını handle et
      if (key.includes('[') && key.includes(']')) {
        const arrayKey = key.split('[')[0];
        const index = parseInt(key.split('[')[1].split(']')[0]);
        return current?.[arrayKey]?.[index];
      }
      return current?.[key];
    }, obj);
  };

  const { data = [], isFetched,refetch } = useQuery({
    queryKey: ['/list', 'referance'],
    queryFn: async () => {
      try {
        const { data } = await requests.referance.list();
        console.log('Gelen Data:', data); // Gelen veriyi konsola yazdır
        return data;
      } catch (error) {
        console.error('API Error:', error);
        return []; // Hata durumunda boş bir dizi döndür
      }
    },
    placeholderData: [], // Başlangıçta boş bir dizi
  });

  const isWasgingLabel = Array.isArray(data)
    ? data.filter((item) => item.labelCategory === 'SALLANTI KARTI HOME')
    : [];

  console.log("wasginggg",data)
  
  // useMemo ile options'ı memoize et - sınırsız döngüyü önler
  const options = useMemo(() => 
    isWasgingLabel.map(({ id, code }) => ({
      value: code, // id yerine code kullan
      label: code,
      id: id // id'yi de sakla gerekirse
    })), 
    [isWasgingLabel]
  );

  useEffect(() => {
    //refetch();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log('Formik Values:', values); // Formik values değerini konsola yazdır
    console.log('Name prop:', name); // Name prop'unu konsola yazdır
    
    // name prop'undan referanceCode değerini al
    const referanceCodeValue = getValueFromPath(name, values);
    console.log('ReferanceCode Value:', referanceCodeValue);
    
    if (referanceCodeValue && isFetched) {
      const select = options.find(({ value }) => value === referanceCodeValue);
      setSelected(select || null); // Eşleşme bulunamazsa null olarak ayarla
    } else if (!referanceCodeValue && isFetched) {
      // Eğer referanceCode yoksa selected'i sıfırla
      setSelected(null);
    }
    // eslint-disable-next-line
  }, [name, isFetched]);

  const handleChange = (selectedOption) => {
    setSelected(selectedOption);
    // Formik'e code değerini gönder
    setFieldValue(name, selectedOption?.value || '');
  };

  return (
    <SearchSelect
      name={name}
      label=""
      options={options}
      value={selected || null} // `selected` boşsa null döndür
      onChange={handleChange}
    />
  );
}
